export const path = (p: string) =>
  `${import.meta.env.BASE_URL}${p}`.replaceAll("//", "/");

export function getErrorMessage(e: unknown): string {
  // DOMException かどうか（ブラウザ環境）
  if (e instanceof DOMException) {
    switch (e.name) {
      case "NotAllowedError":
        return "ユーザーがマイク許可を拒否しました";
      case "NotFoundError":
        return "利用可能なマイクが見つかりません";
      case "NotReadableError":
        return "デバイスにアクセスできません（他のアプリが使用中など）";
      case "OverconstrainedError": {
        // 仕様上 constraint 情報がある場合がある
        const constraint = (e as unknown as { constraint?: string }).constraint;
        return `指定した制約を満たすマイクがありません${constraint ? `（${constraint}）` : ""}`;
      }
      case "SecurityError":
        return "セキュリティ制限によりアクセスできません";
      default:
        return e.message || "不明なエラー";
    }
  }

  // 一般的な Error
  if (
    e &&
    typeof e === "object" &&
    "message" in e &&
    typeof (e as { message: unknown }).message === "string"
  ) {
    return (e as { message: string }).message;
  }

  // 文字列が投げられたケース
  if (typeof e === "string") return e;

  return "不明なエラー";
}

// Base64エンコード関数
export function encodeBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (typeof reader.result === "string") {
        // Data URL のプレフィックスを除去してBase64文字列のみ取得
        const base64 = reader.result.split(",")[1];
        resolve(base64);
      } else {
        reject(new Error("Failed to read file as Base64"));
      }
    };
    reader.onerror = () => reject(reader.error);
  });
}

// 画像リサイズ関数
export function resizeImage(
  file: File,
  maxWidth: number = 1024,
  maxHeight: number = 1024,
  quality: number = 0.8,
): Promise<string> {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();

    img.onload = () => {
      // 元画像のサイズを取得
      let { width, height } = img;

      // アスペクト比を維持しながらリサイズ
      if (width > maxWidth || height > maxHeight) {
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        width *= ratio;
        height *= ratio;
      }

      // Canvasのサイズを設定
      canvas.width = width;
      canvas.height = height;

      // 画像を描画
      ctx?.drawImage(img, 0, 0, width, height);

      // Base64として出力（JPEGで圧縮）
      const base64 = canvas.toDataURL("image/jpeg", quality);
      resolve(base64.split(",")[1]); // プレフィックスを除去
    };

    img.onerror = () => reject(new Error("Failed to load image"));
    img.src = URL.createObjectURL(file);
  });
}

